var routes = []
var secondaryRoutes = []
var standaloneRoutes = []

const requireContext = require.context('.', false, /.(core|user)\.(js)$/)
requireContext.keys().forEach(file => {
  const routesFile = requireContext(file)

  if ('default' in routesFile) {
    routes = routes.concat(routesFile.default)
  }
})

export default {routes, secondaryRoutes, standaloneRoutes}
